<template>
  <div id="container" class="container" @contextmenu="preventContextmenu" @copy="preventCopy" @mouseup="handleMouseUp">
    <main id="content" class="l-main" v-if="globalNavigationStore.selectedColor!=='' && currentQuestion">
      <!--Vertical layout-->
      <div v-if="globalNavigationStore.selectedColor==='kokugo'"
         class="p-question -kokugo p-question--vertical"
      >
        <question-information @click="stopQAModal=true" name="S3-8-close-btn">
          <template #chapterTitle>
            <button class="hamburger" @click="skillModal=true" v-if="accountStore.isDebug">
              <span style="line-height: 1;">☰</span>
            </button>
            <markdown-view
                    :class="{'debug-markdown': accountStore.isDebug}"
                    :rawText="selectedQuestionSetTitle" :souruby="accountStore.isDebugSouruby">
            </markdown-view>
          </template>
          <template #chapterPageNumber v-if="selectedQuestionPageRange">
            <div class="c-parts-text-page -question">P {{selectedQuestionPageRange}}</div>
          </template>
          <template #chapterCorrectWrongList>
            <question-correct-wrong
                :question-correct-wrong-list="workStore.questionCorrectWrongList"
                :position="qIndex">
            </question-correct-wrong>
          </template>
          <template #previousNextButton>
            <div class="previous-next-button" v-if="!workStore.isSearchQuestionById">
              <div class="button-frame">
                <a href="javascript:void(0)" class="prev -disabled" :tabindex="-1" name="S3-8-prev-skip-btn"><span>前へ</span></a>
                <span class="delimiter"></span>
                <a href="javascript:void(0)" class="next -disabled" :tabindex="-1" name="S3-8-next-skip-btn"><span>次へ</span></a>
              </div>
            </div>
          </template>
        </question-information>

        <div class="p-question__inner" ref="refModQuestionInner">
          <div class="p-question__main">
            <div class="p-question__body">
              <div class="p-question__body__judge-question">
                <markdown-view
                      :class="{'debug-markdown': accountStore.isDebug}"
                      :rawText="currentQuestion.text"
                      :workId="currentQuestion.work_id" :souruby="accountStore.isDebugSouruby">
                </markdown-view>
              </div>
              <div class="p-question__body__judge-answer" ref="refAnswerExplanation">
                <answer-explanation
                      :is-vertical="true"
                      :from-judge-page="true"
                      :is-souruby="accountStore.isDebugSouruby"
                      :commentary="currentQuestion.commentary"
                      :workId="currentQuestion.work_id"
                      :is-debug="accountStore.isDebug"
                      :answer-explanations="getExplanationAnswer">
                </answer-explanation>
              </div>
            </div>
            <question-status
                tag-position="sideRight"
                :tag-label="getQuestionLabels" :tag-correct="getTagCorrect"
                :is-tag-review-required="!getReviewTag"
                @click="">
            </question-status>
          </div>
          <answer-area :from-judge-page="true" :is-vertical="true" @body-height="questionBodyHeight()" page-name="S3-8">
            <template #helpTag>
              <question-help
                      @click="openModal($event)"
                      tag-position="sideLeft"
                      :is-hint="!!currentQuestion.hint"
                      :is-point="!!getPoint(currentQuestion.section_id)"
                      page-name="S3-8"
              ></question-help>
            </template>
            <template #answerButton>
              <button-blue @click="verifyAnswer()" :disabled="isButtonDisabled()" :tab-index="3" :is-vertical="true" :label-normal="true" name="S3-8-next-question-btn">○×を決定</button-blue>
            </template>
            <template #answerList>
              <answer-text-for-grading
                    :is-vertical="true"
                    :final-answer="getFinalAnswer"
                    @grading-answer="gradingAnswer=$event">
              </answer-text-for-grading>
            </template>
            <template #questionId>
              <div class="codeText">
                qid:{{currentQuestion.work_id}}-{{currentQuestion.id}}
                <br>
                <a class="reportLink" @click="reportModal=true">問題の誤り・不具合を報告</a>
              </div>
            </template>
          </answer-area>
        </div>
      </div>

      <!--Horizontal layout-->
      <div v-else
        :class="['p-question p-question--horizontal -'+ globalNavigationStore.selectedColor]"
      >
        <question-information @click="stopQAModal=true" name="S3-7-close-btn">
          <template #chapterTitle>
            <button class="hamburger" @click="skillModal=true" v-if="accountStore.isDebug">
              <span style="line-height: 1;">☰</span>
            </button>
            <markdown-view
                    :class="{'debug-markdown': accountStore.isDebug}"
                    :rawText="selectedQuestionSetTitle" :souruby="accountStore.isDebugSouruby">
            </markdown-view>
          </template>
          <template #chapterPageNumber v-if="selectedQuestionPageRange">
            <div class="c-parts-text-page -question">P {{selectedQuestionPageRange}}</div>
          </template>
          <template #chapterCorrectWrongList>
            <question-correct-wrong
                :question-correct-wrong-list="workStore.questionCorrectWrongList"
                :position="qIndex">
            </question-correct-wrong>
          </template>
          <template #previousNextButton>
            <div class="previous-next-button" v-if="!workStore.isSearchQuestionById">
              <div class="button-frame">
                <a href="javascript:void(0)" class="prev -disabled" :tabindex="-1" name="S3-8-prev-skip-btn"><span>前へ</span></a>
                <span class="delimiter"></span>
                <a href="javascript:void(0)" class="next -disabled" :tabindex="-1" name="S3-8-next-skip-btn"><span>次へ</span></a>
              </div>
            </div>
          </template>
        </question-information>
        <div class="p-question__main" id="jsQuestionHorizontal">
          <question-status
              tag-position="sideLeft"
              :tag-label="getQuestionLabels" :tag-correct="getTagCorrect"
              :is-tag-review-required="!getReviewTag"
              @click="">
          </question-status>
          <div class="p-question__body" ref="refModQuestionBody">
            <div class="p-question__body__judge-question">
              <markdown-view
                    :class="{'debug-markdown': accountStore.isDebug}"
                    :rawText="currentQuestion.text"
                    :workId="currentQuestion.work_id" :souruby="accountStore.isDebugSouruby">
              </markdown-view>
            </div>
            <div class="p-question__body__judge-answer" ref="refAnswerExplanation">
              <answer-explanation
                      :from-judge-page="true"
                      :is-souruby="accountStore.isDebugSouruby"
                      :commentary="currentQuestion.commentary"
                      :workId="currentQuestion.work_id"
                      :is-debug="accountStore.isDebug"
                      :answer-explanations="getExplanationAnswer"
                      :is-keyboard="isKeyboard">
              </answer-explanation>
            </div>
          </div>
          <question-help
                  @click="openModal($event)"
                  tag-position="sideRight"
                  :is-hint="!!currentQuestion.hint"
                  :is-point="!!getPoint(currentQuestion.section_id)"
                  page-name="S3-8"
          ></question-help>
        </div>
        <answer-area @body-height="questionBodyHeight()" :from-judge-page="true" page-name="S3-8">
          <template #answerButton>
            <button-blue @click="verifyAnswer()" :disabled="isButtonDisabled()" :tab-index="3" :arrow="true" name="S3-8-next-question-btn">○×を決定</button-blue>
          </template>
          <template #answerList>
            <answer-text-for-grading
                    :final-answer="getFinalAnswer"
                    :is-keyboard="isKeyboard"
                    :is-science="isScience"
                    @grading-answer="gradingAnswer=$event">
            </answer-text-for-grading>
          </template>
          <template #questionId>
            <div class="codeText">
              qid:{{currentQuestion.work_id}}-{{currentQuestion.id}}
              <a class="reportLink" @click="reportModal=true">問題の誤り・不具合を報告</a>
            </div>
          </template>
        </answer-area>
      </div>
      <!--For make focus cycle-->
      <span tabindex="4" @focus="focusFirstElement()"></span>
      <popup-modal v-model="stopQAModal" @close="stopQAModal=false" @close-layer="stopQAModal=false" name="S3-8-close-learning-btn">
        <template #main>
          <div class="c-popup-body__head">
            <p class="c-popup-body__head-title">
              学習を中断しますか？
            </p>
          </div>
          <div class="c-popup-body__titleBox">
            <div class="c-popup-body__titleBox-logout u-text-caution" v-if="workStore.isReviewQuestion || workStore.isPrevQuestionHistory || (workStore.mission !== null && workStore.mission.kind !== missionKind.NEW)">
              学習を中断した場合，ここまでの解答は<br>学習記録に残りませんので，ご注意ください。
            </div>
            <div class="c-popup-body__titleBox-logout" v-else>
              中断した場合は、その続きから再開することができます。
            </div>
          </div>
        </template>
        <template #footer>
          <div class="c-button -col2">
            <a @click="stopQAModal=false" name="S3-8-continue-learning-btn" class="c-button-white -medium -font-large">
              <span class="label">中断せず学習を続ける</span>
            </a>
            <button-blue @click="closeModal('stopAQModal')" :medium="true" :label-normal="true" name="S3-8-stop-learning-btn">学習を中断する</button-blue>
          </div>
        </template>
      </popup-modal>

      <!-- この項目のポイント -->
      <popup-modal v-model="pointModal" @close="closeModal('point')" @close-layer="pointModal=false"
        :is-point-hint-modal="true"
        name="S3-8-point-close-btn"
        :modal-position-vertical="globalNavigationStore.selectedColor==='kokugo'"
      >
        <template #main>
          <div class="pointBlock">
            <div class="fixed-title-area">
              <div class="title">この項目のポイント</div>
            </div>
            <div class="text">
              <markdown-view
                      :class="{'debug-markdown': accountStore.isDebug}"
                      :rawText="getPoint(currentQuestion.section_id)"
                      :workId="currentQuestion.work_id" :souruby="accountStore.isDebugSouruby">
              </markdown-view>
            </div>
          </div>
        </template>
      </popup-modal>

      <!-- ヒント -->
      <popup-modal v-model="hintModal" @close="closeModal('hint')" @close-layer="hintModal=false"
         :is-point-hint-modal="true"
         name="S3-8-hint-close-btn"
         :modal-position-vertical="globalNavigationStore.selectedColor==='kokugo'"
      >
        <template #main>
          <div class="hintBlock">
            <div class="fixed-title-area">
              <div class="title">ヒント</div>
            </div>
            <div class="text">
              <markdown-view
                      :class="{'debug-markdown': accountStore.isDebug}"
                      :rawText="currentQuestion.hint"
                      :workId="currentQuestion.work_id" :souruby="accountStore.isDebugSouruby">
              </markdown-view>
            </div>
          </div>
        </template>
      </popup-modal>
      <!--Skill modal-->
      <popup-modal v-model="skillModal" @close="skillModal=false" @close-layer="skillModal=false" :is-help-modal="true">
        <template #main>
          <div class="topNoticeBlock">
            <div class="text">
              スキル: {{allSkills()}}
            </div>
            <br>
            <div class="text">
              <div>総ルビ表示の設定:</div>
              <div class="c-parts-toggle" :class="{'c-parts-toggle--active': accountStore.isDebugSouruby}" @click="toggleRubySwitch()">
                <span class="label">{{accountStore.isDebugSouruby?'ON':'OFF'}}</span>
                <span class="toggle"></span>
              </div>
            </div>
          </div>
        </template>
      </popup-modal>
      <!-- report modal -->
      <error-report-modal 
        v-model="reportModal"
        sid="S3-8" 
        :subject="subject_field"
        :qid="`${currentQuestion.work_id}-${currentQuestion.id}`"
        :uid="`user ${accountStore.userId}`"
        :workname="workStore.selectedWork[workStore.selectedWorkIndex].name"
        :qcode="currentQuestion.code"
        :ucid="`${accountStore.studentProfile.profile.classroom.id}`"
        :usid="`${accountStore.studentProfile.profile.school.id}`"
        @close="reportModal=false" 
        @close-layer="reportModal=false">
      </error-report-modal>
    </main>
  </div>
</template>

<script setup lang="ts">
  import {ref, onMounted, onUnmounted, nextTick, computed} from 'vue';
  import {useRoute, useRouter} from "vue-router"
  import {event} from "vue-gtag"
  import * as Sentry from "@sentry/browser";
  import AudioPlayer from '@/consts/sounds';
  import remove_markdown from "@/util/remove_markdown";
  import { isEnvCaptureGoogleAnalyticsEvents } from "@/util/env"
  import hideMiniContextMenuOnEdge from "@/util/diabled-context-menu"
  import {LAYOUT, QUIZTYPE} from '@/consts/answer_column';
  import {DISABLED_BUTTON_TIME, MAX_TRANSITION_TIME} from "@/consts/study"
  import {MISSIONKIND_SORT} from "@/consts/mission";
  import { useAccountStore } from '@/store/student/account_store';
  import { useWorkStore } from '@/store/student/work_store';
  import { useGlobalNavigationStore } from '@/store/student/global_navigation_store';
  import { useHomeworkStore } from '@/store/student/homework_store';
  import local_time from "@/util/datetime";
  import getCsrfTokenFromCookie from "@/util/csrf-token";

  const audioPlayer = AudioPlayer.getInstance()
  const accountStore = useAccountStore()
  const workStore = useWorkStore()
  const globalNavigationStore = useGlobalNavigationStore()
  const refModQuestionInner = ref(null)
  const refModQuestionBody = ref(null)
  const refAnswerExplanation = ref(null)
  const route = useRoute()
  const router = useRouter()
  const stopQAModal = ref(false)
  const skillModal = ref(false)
  const hintModal = ref(false)
  const pointModal = ref(false)
  const reportModal = ref(false)
  const gradingAnswer = ref<boolean | null> (null)
  const missionKind = MISSIONKIND_SORT
  // copy store question_index to local variable
  const qIndex = ref(workStore.questionIndex)
  const subject_field = workStore.selectedWork[workStore.selectedWorkIndex].subject_field

  onMounted(() => {
    // 内側のスクロール動きのため外側(body)スクロールを禁止する（ipadの不具合）
    let body_tag = document.getElementsByTagName('body')[0]
    body_tag.classList.add("unscrollable")
    if(accountStore.isDebug){
      accountStore.saveDebugSouruby(true)
    }
    else{
      accountStore.saveDebugSouruby(accountStore.isSouruby)
    }
    window.addEventListener('pagehide', onPageHide, false);
    window.history.pushState({}, null, null);
    window.addEventListener('popstate', browserBackHandler)
    window.addEventListener('resize', questionBodyHeight);
    if(workStore.isReviewQuestion){
      document.title = "要復習問題" + (qIndex.value + 1) + " | "
          + remove_markdown(workStore.selectedWork[workStore.selectedWorkIndex].name)
    }else{
      document.title = workStore.questions[qIndex.value].sort_order + " | "
          + remove_markdown(selectedQuestionSetTitle.value)+ " | "
          + remove_markdown(workStore.selectedWork[workStore.selectedWorkIndex].name)
    }
    const time_diff = Date.now() - workStore.transitTime
    if(time_diff > MAX_TRANSITION_TIME) {
      // after throw this event custom context automatically deleted
      // https://docs.sentry.io/platforms/javascript/guides/vue/enriching-events/scopes/#local-scopes
      Sentry.withScope(function(scope) {
        scope.setContext("Transition Information", {
          name: "Judge",
          duration: `${time_diff} ms`,
          question_id: workStore.questions[qIndex.value].id,
          work_id: workStore.questions[qIndex.value].work_id,
        });
        scope.setLevel("warning");
        Sentry.captureMessage("画面遷移で5秒以上かかる");
      });
    }
    // reset transit time start
    workStore.saveTransitTime(0)
    nextTick(() => {
      setTimeout(() => {
        // NFR-3683 非活性されたボタンを500ミリ秒以降に活性化する
        workStore.saveIsDisabledButton(false)
      }, DISABLED_BUTTON_TIME)
    })
  })
  onUnmounted(() => {
    window.removeEventListener('pagehide', onPageHide, false)
    window.removeEventListener('popstate', browserBackHandler, false)
    window.removeEventListener('resize', questionBodyHeight, false)
  })
  const selectedWorkId = workStore.selectedWork[workStore.selectedWorkIndex]?.id

  // NFR-5990: make a computed property for current question so every changes in question index will reflect in current question
  const currentQuestion = computed(() => {
    // if question is loaded and current question is present then return the current question
    if (workStore.questions.length > 0 && qIndex.value < workStore.questions.length) {
      return workStore.questions[qIndex.value];
    }
    // if question is not loaded or current question is not present then return null
    return null;
  });
  const selectedQuestionSetTitle = computed(() => {
    if(workStore.isSearchQuestionById){
      for(let section of workStore.sections){
        if(section.id==workStore.questions[qIndex.value].section_id){
          for(let question_set of section.question_sets){
            if(question_set.id == workStore.questions[qIndex.value].question_set_id){
              return question_set.title
            }
          }
        }
      }
      return ""
    }
    // NFR-3198, Optional chaining operator (?.) to avoid Undefined cannot access property <property_name>
    return workStore.selectedQuestionSet[workStore.questions[qIndex.value]?.question_set_id]?.title || ""
  })
  const selectedQuestionPageRange = computed(() => {
    // NFR-5754: save the current learning question
    const selectedQuestion = workStore.questions[qIndex.value]
    if(selectedQuestion){
      if(selectedQuestion.textbook_startpage === '0' || selectedQuestion.textbook_endpage === '0'){
        return ''
      } 
      else if(selectedQuestion.textbook_startpage === selectedQuestion.textbook_endpage){
        return selectedQuestion.textbook_startpage;
      } 
      else {
        return `${selectedQuestion.textbook_startpage}-${selectedQuestion.textbook_endpage}`
      }
    } else {
      return ''
    }
  })
  const getQuestionLabels = computed(() => {
    // NFR-5867: if question is loaded and current question is present then return the question labels
    if(workStore.questions.length > 0 && workStore.questions[qIndex.value]){
      return workStore.questions[qIndex.value].question_labels.map(item => item.name)
    } else {
      return []
    }
  })
  const getReviewTag = computed(() => {
    let tag = workStore.reviewTags.filter(item =>
        item.question.id == workStore.questions[qIndex.value].id
    )
    if(tag.length>0){
      return true
    }
    else{
      return false
    }
  })
  const getTagCorrect = computed(() => {
    const question = workStore.questions[qIndex.value]
    if(question){
      let is_correct = workStore.questionProgress[question.id]
      if(!!is_correct){
        return is_correct.is_done_correctly
      }
      else{
        return false
      }
    }
    else{
      return false
    }
  })
  const isScience = computed(() => {
    return subject_field === '理科'
  })
  const isKeyboard = computed(() => {
    return subject_field === '理科' || subject_field === '数学'
  })
  const getExplanationAnswer = computed(() => {
    let explanationAnswer = []
    for(let quiz of workStore.questions[qIndex.value].quizzes){
      explanationAnswer.push(
        {
          label: quiz.label,
          answers: [formatAnswer(quiz.body.exampleAnswer)],
          gradingHint: quiz.body.gradingHint,
          isHalf: quiz.display_options.textInputFormat === LAYOUT.HALF,
          isMulti: quiz.display_options.textInputFormat === LAYOUT.MULTI,
          prefix: quiz.body.prefix,
          suffix: quiz.body.suffix
        }
      )
    }
    return explanationAnswer
  })
  const getFinalAnswer = computed(() => {
    let quiz = workStore.questions[qIndex.value].quizzes[0]
    let answer = workStore.initialAnswer[qIndex.value].quiz_histories[0].answer
    return {
        answer: formatAnswer(answer),
        isHalf: quiz.display_options.textInputFormat === LAYOUT.HALF,
        isMulti: quiz.display_options.textInputFormat === LAYOUT.MULTI,
        prefix: quiz.body.prefix || '',
        suffix: quiz.body.suffix || '',
        label: quiz.label || '',
        isNoAnswer: quiz.answer_format === QUIZTYPE.NO_ANSWER
    }
  })
  const abortStudyLog = (action: string) => {
    const logData = {
      "abort_action" : action,
      "work_id" : selectedWorkId,
      "question_code": workStore.questions[qIndex.value]?.code || null,
      "question_start_datetime": workStore.start_date,
      "question_abort_datetime": local_time()
    }
    const jsonData = {
      'token' : getCsrfTokenFromCookie(document.cookie),
      'log' : logData
    }
    const headers = {
      type: 'application/json',
    };
    const blob = new Blob([JSON.stringify(jsonData)], headers);
    return blob
  }
  function getPoint(section_id) {
    let section = workStore.sections.filter(item => item.id == section_id)
    if(section.length>0){
      return section[0].point
    }
    else{
      return ""
    }
  }
  // 理科の場合、アルファベットは正体にする必要があるので別にフォーマットを変更する
  function formatAnswer(answer){
    if (isScience.value) {
      if (!answer.includes("\\ce")) { // \\ceコマンドを使うとアルファベットが正体になるので除外する
        answer = answer.replaceAll(/[\$](\\|[0-9]*)([A-Za-z])/g, "$\\rm $1$2")
      }
    }
    return answer
  }
  function allSkills(){
    return workStore.questions[qIndex.value].skills.map(item => item.name).join(', ')
  }
  function toggleRubySwitch(){
    accountStore.saveDebugSouruby(!accountStore.isDebugSouruby)
  }
  function onPageHide(evt: Event): void {
    // NFR-5116: swap study break data
    workStore.swapStudyBreakData('judge')
    const question = workStore.questions[qIndex.value]
    if(isEnvCaptureGoogleAnalyticsEvents()){
      navigator.sendBeacon('/student/api/log/abort_study', abortStudyLog("window_unload"));
      event('abort_study', {
        'work_id': selectedWorkId,
        'subject_field': subject_field,
        'question_id': question?.id,
        'question_index': qIndex.value + 1,
        'screen_code': route.meta.screenCode,
        'abort_action': "window_unload"
      })
    }
  }
  function browserBackHandler(evt: PopStateEvent): void{
    window.history.pushState({}, null, null);
    stopQAModal.value = true
  }
  function openModal(modal){
    if(modal == 'hint'){
      hintModal.value = true
      if(isEnvCaptureGoogleAnalyticsEvents()){
        event('show_hint', {
          'work_id': selectedWorkId,
          'question_id': workStore.questions[qIndex.value].id,
          'question_index': qIndex.value + 1
        })
      }
    }
    else if(modal == 'point'){
      pointModal.value = true
      if(isEnvCaptureGoogleAnalyticsEvents()){
        event('show_quesion_point', {
          'work_id': selectedWorkId,
          'question_id': workStore.questions[qIndex.value].id,
          'question_index': qIndex.value + 1
        })
      }
    }
  }
  async function closeModal(modal){
    if(modal=='stopAQModal'){
      // setting study end time for current question
      workStore.saveQuestionStudyEndTime()
      // NFR-5116: swap study break data
      workStore.swapStudyBreakData('judge')
      workStore.saveIsMissionQuestion(false)
      useHomeworkStore().saveIsHomework(false)
      workStore.saveIsLearningPage(false)
      if(accountStore.isSoundEnabled){audioPlayer.closeSound().play()}
      if(isEnvCaptureGoogleAnalyticsEvents()){
        navigator.sendBeacon('/student/api/log/abort_study', abortStudyLog("abort_button_click"));
        event('abort_study', {
          'work_id': selectedWorkId,
          'subject_field': subject_field,
          'question_id': workStore.questions[qIndex.value].id,
          'question_index': qIndex.value + 1,
          'screen_code': route.meta.screenCode,
          'abort_action': "abort_button_click"
        })
      }
      router.push({path:!!workStore.learningStartPage?workStore.learningStartPage.path:'/student/'}).then(() => {
        workStore.saveIsSearchQuestionById(false),
        workStore.saveIsLearningMode(false)
      })
    }
    else if(modal == 'hint'){
      hintModal.value = false
    }
    else if(modal == 'point'){
      pointModal.value = false
    }
  }
  function isButtonDisabled(){
    if(gradingAnswer.value === null){
      return true
    }else if(workStore.isDisabledButton){
      return true
    }
  }
  async function verifyAnswer(){
    workStore.saveIsDisabledButton(true)
    if(gradingAnswer.value){
      workStore.saveQuizCorrectAnswer({id:0, is_correct: true})
      workStore.saveQuestionCorrectAnswer( true)
      workStore.saveSingleQuestionCorrectWrongList({result: true, progress: 1})
      if(isEnvCaptureGoogleAnalyticsEvents()){
        event('answer_is_correct', {
          'work_id': selectedWorkId,
          'question_id': workStore.questions[qIndex.value].id,
          'question_index': qIndex.value + 1
        })
      }
    }else{
      workStore.saveQuizCorrectAnswer({id:0, is_correct: false})
      workStore.saveQuestionCorrectAnswer(false)
      workStore.saveSingleQuestionCorrectWrongList({result: false, progress: 1})
      if(isEnvCaptureGoogleAnalyticsEvents()){
        event('answer_is_incorrect', {
          'work_id': selectedWorkId,
          'question_id': workStore.questions[qIndex.value].id,
          'question_index': qIndex.value + 1
        })
      }
    }
    workStore.saveQuestionStudyEndTime()
    router.push({name:'answer'})
  }
  function questionBodyHeight(){
      nextTick(() =>{
        if(globalNavigationStore.selectedColor=='kokugo'){
          let headerH = document.getElementsByClassName("p-question__header")[0].clientHeight;
          let mainBoxH = document.documentElement.clientHeight;
          let questionInnerH:any = refModQuestionInner.value
          questionInnerH.style.height =  (mainBoxH - headerH) + 'px';
        }else{
          let mainBoxH = document.documentElement.clientHeight;
          let headerH = document.getElementsByClassName("p-question__header")[0].clientHeight;
          let footerH = document.getElementsByClassName("p-question__footer")[0].clientHeight;
          let questionBodyH:any = refModQuestionBody.value
          questionBodyH.style.height = (mainBoxH - headerH - footerH - 60) + 'px';
        }
        let answerExplanation:any = refAnswerExplanation.value
        answerExplanation.scrollIntoView({block: "start", inline: "nearest"})
      });
  }

  function focusFirstElement() {
    const answerArea:any = document.getElementsByClassName("c-accordion__cont")
    if(answerArea.length){
      const focusableElements = [...answerArea[0].querySelectorAll('[tabindex]:not([tabindex="-1"])')]
      focusableElements[0]?.focus()
    }
  }
  function preventContextmenu(event:Event){
    // NFR-4573, if student is not debug mode then disabled context menu
    if(!accountStore.isDebug){
      event.preventDefault()
    }
  }
  function preventCopy(event:Event){
    // NFR-4573, if student is not debug mode then disabled CTRL + c to copy text
    if(!accountStore.isDebug){
      event.preventDefault()
    }
  }
  function handleMouseUp() {
    // NFR-4573, if student is not debug mode then disabled Edge browser mini-context menu
    if(!accountStore.isDebug){
      hideMiniContextMenuOnEdge()
    }
  }
</script>
